import { useDateAdapterUtils } from '../DatePickersUtils/useDateAdapterUtils';
import startOfWeek from 'date-fns/startOfWeek';
import endOfWeek from 'date-fns/endOfWeek';

export const useFormatDate = () => {
  const { format, date } = useDateAdapterUtils();

  const getFormattedDate = (startDate, endDate) => {
    const formattedStartDate = startDate ? format(startDate) : '';
    const formattedEndDate = endDate ? format(endDate) : '';

    if (formattedStartDate && formattedEndDate) {
      return `${formattedStartDate} - ${formattedEndDate}`;
    }

    return formattedStartDate || formattedEndDate || '';
  };

  const getFormattedPlaceholder = () => {
    const startOfWeekDate = startOfWeek(new Date());
    const endOfWeekDate = endOfWeek(new Date());

    // Need to align placeholder's dates to match the date adapter format
    const dateAdapterStartOfWeekDate = date(startOfWeekDate);
    const dateAdapterEndOfWeekDate = date(endOfWeekDate);

    return getFormattedDate(
      dateAdapterStartOfWeekDate,
      dateAdapterEndOfWeekDate
    );
  };

  return {
    getFormattedDate,
    getFormattedPlaceholder
  };
};
